import { createMuiTheme } from '@material-ui/core';
import hostClient from '../../host/HostClient';
import {
    generateDefaultImages,
    generateEposNowTheme,
    generateDefaultThemeOptions,
    generateThemeOptions,
    generateBarclayCardTheme,
    generateRmsTheme,
    generateCardSaverTheme,
    generateWorldPayTheme,
    generateZeroBubbleTheme,
    generateBNATheme,
} from './ThemeGenerators';
import { hosts } from '../../host/Hosts';
import { IThemeImageOptions, IThemeObjectOptions } from '../types';

/**Creates a MUI theme  */
class ThemeObject {
    constructor(public themeOptions?: IThemeObjectOptions, public themeImages?: IThemeImageOptions) {
        const host = hostClient.host;

        if (!themeOptions) {
            this.themeOptions = generateDefaultThemeOptions();
        }
        if (!themeImages) {
            this.themeImages = generateDefaultImages();
        }
        //@TODO: do this better
        if (host === hosts.barclaycard) {
            this.themeOptions = {
                ...(this.themeOptions as IThemeObjectOptions),
                ...generateBarclayCardTheme(),
            };
        }
        if (host === hosts.rms) {
            this.themeOptions = {
                ...(this.themeOptions as IThemeObjectOptions),
                ...generateRmsTheme(),
            };
        }
        if (host === hosts.cardsaver) {
            this.themeOptions = {
                ...(this.themeOptions as IThemeObjectOptions),
                ...generateCardSaverTheme(),
            };
        }
        if (host === hosts.eposnow) {
            this.themeOptions = {
                ...(this.themeOptions as IThemeObjectOptions),
                ...generateEposNowTheme(),
            };
        }
        if (host === hosts.worldpay) {
            this.themeOptions = {
                ...(this.themeOptions as IThemeObjectOptions),
                ...generateWorldPayTheme(),
            };
        }
        if (host === hosts.zerobubble) {
            this.themeOptions = {
                ...(this.themeOptions as IThemeObjectOptions),
                ...generateZeroBubbleTheme(),
            };
        }
        if (host === hosts.bna) {
            this.themeOptions = {
                ...(this.themeOptions as IThemeObjectOptions),
                ...generateBNATheme(),
            };
        }
    }
    /**Generates the theme from the theme options and the objects theme options and theme images */
    public createTheme() {
        return createMuiTheme(generateThemeOptions(this.themeOptions!, this.themeImages));
    }
    /**Set the themes options */
    public setThemeOptions(themeOptions: IThemeObjectOptions) {
        this.themeOptions = themeOptions;
    }
    /**Sets the themes images */
    public setThemeImages(themeImages: IThemeImageOptions) {
        this.themeImages = themeImages;
    }
}

export default ThemeObject;
